import Angular from "angular";
import Controller from "./new-booking-date.controller";
import Template from "./new-booking-date.html";
import Bookings from "../../services/bookings.service";
import Workloads from "../../services/workload.service";

export const NewBookingDateView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.new-booking-date', [
    Bookings.name,
    Workloads.name
]);



// WEBPACK FOOTER //
// ./src/modules/main/views/new-booking-date/new-booking-date.js